import React from "react";
import { Placeholder, VisitorIdentification } from "@sitecore-jss/sitecore-jss-react";
import Helmet from "react-helmet";
import { PORTALTHIRD_BASE_URL } from "../constants/constants";
//import Topbar from ".../Topbar";

import "../style/main.scss";
import styles from "../style/layout_components/Layout.module.scss";
/*
  APP LAYOUT
  This is where the app's HTML structure and root placeholders should be defined.

  All routes share this root layout by default (this could be customized in RouteHandler),
  but components added to inner placeholders are route-specific.
*/

const DefaultLayout = ({ route }) => (
  <React.Fragment>
    {/* react-helmet enables setting <head> contents, like title and OG meta tags */}
    <Helmet>
      <title>{(route.fields && route.fields.pageTitle && route.fields.pageTitle.value) || "Page"}</title>
      <link rel="manifest" href={`/${PORTALTHIRD_BASE_URL}/manifest.json`}></link>
    </Helmet>
    {/*
      VisitorIdentification is necessary for Sitecore Analytics to determine if the visitor is a robot.
      If Sitecore XP (with xConnect/xDB) is used, this is required or else analytics will not be collected for the JSS app.
      For XM (CMS-only) apps, this should be removed.

      VI detection only runs once for a given analytics ID, so this is not a recurring operation once cookies are established.

      <Topbar>
        <Placeholder name="pd-header" rendering={route}/> 
      </Topbar>
    */}
    <VisitorIdentification />
    <div className="site portaalderden">
      <Placeholder name="pd-header" rendering={route} />
      {/* root placeholder for the app, which we add components to using route data */}
      <div className={styles.wrap}>
        <Placeholder name="pd-column-1" rendering={route} />
        <main>
          <Placeholder name="pd-column-2" rendering={route} />
        </main>
      </div>
      <Placeholder name="pd-footer" rendering={route} />
    </div>
  </React.Fragment>
);

export default DefaultLayout;
